import EvaluationScaleForm from './EvaluationScaleForm';

function EvaluationScaleCreate() {
  return <EvaluationScaleForm />;
}

export default EvaluationScaleCreate;
